import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { DEFAULT_CLOSED_MESSAGE, isRegistrationOpen } from "./topShopRegistration";

export const TOP_SHOP_REGISTRATION_KEY = ["top-shop", "registration"] as const;

export type TopShopRegistrationRow = {
  id: string;
  applications_open: boolean;
  applications_close_at: string | null;
  applications_closed_message: string | null;
};

export async function fetchTopShopRegistration(): Promise<TopShopRegistrationRow> {
  const { data, error } = await supabase
    .from("programs")
    .select("id, applications_open, applications_close_at, applications_closed_message")
    .eq("slug", "top-shop")
    .single();
  if (error) throw error;
  return data as TopShopRegistrationRow;
}

/** Fetches a fresh program row and applies the shared open rule. */
export async function checkTopShopRegistrationOpenNow(): Promise<boolean> {
  const row = await fetchTopShopRegistration();
  return isRegistrationOpen(row.applications_open, row.applications_close_at, new Date());
}

export function useTopShopRegistration() {
  const query = useQuery({ queryKey: TOP_SHOP_REGISTRATION_KEY, queryFn: fetchTopShopRegistration });
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = window.setInterval(() => setNow(new Date()), 60_000);
    return () => window.clearInterval(id);
  }, []);
  const row = query.data;
  return {
    program: row,
    isOpen: row ? isRegistrationOpen(row.applications_open, row.applications_close_at, now) : false,
    closeAt: row?.applications_close_at ?? null,
    closedMessage: row?.applications_closed_message?.trim() ? row.applications_closed_message : DEFAULT_CLOSED_MESSAGE,
    isLoading: query.isLoading,
    error: query.error,
  };
}
